module.exports = __webpack_public_path__ + "img/clipboard.6ab66b43.svg";